import { createRoutesFromElements, Route } from 'react-router-dom';

import LayoutMain from 'src/presentations/components/templates/Main';
import LayoutRoot from 'src/presentations/components/templates/Root';
import LoginPage from 'src/presentations/components/pages/loginPage';
import Analytics from 'src/presentations/components/pages/analytics';
import LandingPage from 'src/presentations/components/pages/landing';
import { PerformanceAnalysis } from 'src/presentations/components/pages/performance/PerformanceAnalysis';
import PdfViewer from 'src/presentations/components/pages/pdfViewer/PdfViewer';

import NotFound from 'src/containers/NotFound';
import Forbidden from 'src/containers/Forbidden';
import UnderConstructionPage from 'src/presentations/components/pages/underConstruction/UnderConstructionPage';
import { PermissionType } from 'src/types/permission';
import SettingsPage from 'src/presentations/components/pages/settings/SettingsPage.tsx';
import UserProfilePage from 'src/presentations/components/pages/settings/UserProfilePage.tsx';
import LegalEntitiesPage from 'src/presentations/components/pages/settings/LegalEntitiesPage';
import ExchangeRatePage from 'src/presentations/components/pages/settings/ExchangeRatePage';
import InvoiceChargePage from 'src/presentations/components/pages/settings/InvoiceChargePage';
import CreditTransactionsPage from 'src/presentations/components/pages/settings/CreditTransactionsPage';
import ContractsPage from 'src/presentations/components/pages/settings/ContractsPage';
import DiscountsPage from 'src/presentations/components/pages/settings/DiscountsPage';
import IconGallery from 'src/presentations/components/pages/iconGallery';
import AuditWorkflowPage from 'src/presentations/components/pages/settings/AuditWorkflowPage.tsx';
import RequireAuth from './RequireAuth';
import RequirePermission from './RequirePermission';
import ModelConfigurationPage from '../../presentations/components/pages/settings/ModelConfigurationPage.tsx';
import ServiceProvidersPage from '../../presentations/components/pages/settings/ServiceProvidersPage.tsx';
import { TourLayout } from 'src/presentations/guided-tours';

// Direct imports instead of lazy loading to prevent Suspense flash during navigation
import { Dashboard } from 'src/presentations/components/pages/dashboardPage';
import InternalDashboardPage from 'src/presentations/components/pages/internalDashboard/InternalDashboardPage';
import ActionDetailsPage from 'src/presentations/components/pages/actionDetails/ActionDetails';
import ContractManagerPage from 'src/presentations/components/pages/contractManager/ContractManager';
import AskFreyaPage from 'src/presentations/components/pages/askFreya/AskFreyaPage';
import HelpCenterPage from 'src/presentations/components/pages/HelpCenter/HelpCenterPage';

export const routesConfig = createRoutesFromElements(
  <Route element={<TourLayout />}>
    <Route path='/login' element={<LoginPage />} />
    <Route path='/forbidden' element={<Forbidden />} />
    <Route
      element={
        <RequireAuth>
          <LayoutRoot>
            <LayoutMain />
          </LayoutRoot>
        </RequireAuth>
      }
    >
      <Route path='/' element={<LandingPage />} />
      {/* Protected routes with specific permissions */}
      <Route
        path='/dashboard'
        element={
          <RequirePermission permission={PermissionType.AUDIT}>
            <Dashboard />
          </RequirePermission>
        }
      />

      <Route
        path='/action-details/:id'
        element={
          <RequirePermission permission={PermissionType.AUDIT}>
            <ActionDetailsPage />
          </RequirePermission>
        }
      />

      <Route
        path='/performance'
        element={
          <RequirePermission permission={PermissionType.PERFORMANCE}>
            <PerformanceAnalysis />
          </RequirePermission>
        }
      />

      <Route
        path='/analytics'
        element={
          <RequirePermission permission={PermissionType.REPORT}>
            <Analytics />
          </RequirePermission>
        }
      />

      <Route
        path='/ratecard-manager'
        element={
          <RequirePermission permission={PermissionType.RATECARD}>
            <ContractManagerPage />
          </RequirePermission>
        }
      />

      {/* Routes without specific permission requirements */}
      <Route path='/ask-freya' element={<AskFreyaPage />} />
      <Route path='/help-center' element={<HelpCenterPage />} />
      <Route path='/internal-dashboard' element={<InternalDashboardPage />} />
      <Route path='/under-construction' element={<UnderConstructionPage />} />
      <Route path='/internal/icon-gallery' element={<IconGallery />} />
      <Route path='/configured-rate-card/:shipmentInvoiceId' element={<PdfViewer />} />
      <Route path='/settings' element={<SettingsPage />} />
      <Route path='/settings/legal-entities' element={<LegalEntitiesPage />} />
      <Route path='/settings/user-profile' element={<UserProfilePage />} />
      <Route path='/settings/exchange-rate' element={<ExchangeRatePage />} />
      <Route path='/settings/invoice-charge' element={<InvoiceChargePage />} />
      <Route path='/settings/credit-transactions' element={<CreditTransactionsPage />} />
      <Route path='/settings/model-configuration' element={<ModelConfigurationPage />} />
      <Route path='/settings/service-providers' element={<ServiceProvidersPage />} />
      <Route path='/settings/audit-workflow' element={<AuditWorkflowPage />} />
      <Route path='/settings/contracts' element={<ContractsPage />} />
      <Route path='/settings/discounts' element={<DiscountsPage />} />
    </Route>
    <Route path='*' element={<NotFound />} />
  </Route>
);
